import React from 'react';
import { Save } from 'lucide-react';

const FormActions = ({
  onCancel,
  onSubmit,
  cancelText = 'Cancel',
  submitText = 'Save',
  submitIcon: SubmitIcon = Save,
  loading = false,
  loadingText,
  disabled = false,
  variant = 'default', // 'default', 'danger'
  className = ''
}) => {
  const getSubmitButtonClasses = (variant) => {
    switch (variant) {
      case 'danger':
        return 'bg-red-600 hover:bg-red-700 text-white';
      default:
        return 'bg-blue-600 hover:bg-blue-700 text-white';
    }
  };

  const submitButtonClasses = getSubmitButtonClasses(variant);
  const isDisabled = loading || disabled;

  return (
    <div className={`flex space-x-3 pt-4 border-t border-gray-200 ${className}`}>
      <button
        type="button"
        onClick={onCancel}
        className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        disabled={loading}
      >
        {cancelText}
      </button>
      <button
        type="submit"
        onClick={onSubmit}
        disabled={isDisabled}
        className={`flex-1 flex items-center justify-center space-x-2 px-4 py-2 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed transition-colors ${submitButtonClasses}`}
      >
        <SubmitIcon className="w-4 h-4" />
        <span>{loading ? (loadingText || 'Loading...') : submitText}</span>
      </button>
    </div>
  );
};

export default FormActions;